<rw-modal
  modalId="packageAssignmentModal"
  datapendoid="package-assignment-modal"
  datatestid="package-assignment-modal"
  [title]="'Assign Package to Users'"
  arialabel="Assign Package to Users"
  [dismissible]="true"
  size="xl"
  #modalRef
>
  <div modal-body>
    @if(loading) {
    <rw-spinner
      datapendoid="package-assign-modal-spinner"
      datatestid="package-assign-modal-spinner"
      spinnerclass="rw-spinner-primary"
      size="lg"
    >
    </rw-spinner>
    } @else {
    <div class="row">
      <div class="outerBorder">
        <table show-filter="false" class="table-package-detail table-packages">
          <thead>
            <tr>
              <th>Type</th>
              <th>Assigned</th>
              <th>Remaining</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ Package?.PackageName }}</td>
              <td>
                {{ getAssignedLicenseCount() }}
              </td>
              <td>
                {{ getRemainingLicenseCount() }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row medium">
      <div class="col-sm-12">
        <div class="row p-t-sm p-b-sm">
          <div class="col-sm-6 package-users-select-text">
            <span class="sectionTitle">Select users to assign {{ Package?.PackageName }} to:</span>
          </div>
          <div class="col-sm-2"></div>
          <div class="col-sm-4 searchBar">
            <app-search-control
              id="packageAssignSearchControl"
              [Configuration]="searchControlConfiguration"
              (SearchOccurred)="searchOccurred($event)"
            ></app-search-control>
          </div>
        </div>
        <div class="pkg-assign-table">
          <div>
            <rn-grid [Configuration]="TableConfiguration"></rn-grid>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  <div modal-footer>
    <app-button
      id="closeButton"
      label="CANCEL"
      noContentPadding="true"
      buttonStyle="addUserTeritary"
      (clickActionEmitter)="close()"
    >
    </app-button>
    <app-button
      id="btnAssign"
      [disabled]="!anyUsersSelected()"
      (clickActionEmitter)="assignPackage()"
      label="{{ AssignButtonText }}"
      showProcessing="true"
      [processing]="processing"
      noContentPadding="true"
      buttonStyle="primary"
    >
    </app-button>
  </div>
</rw-modal>
